import { FunctionComponent, useEffect, useRef, useState } from "react";
import { DivInner, DivOuter, Partitioned, SixBoxError, SixBoxGridContainer, SixBoxGridItem, SmallStyledInput } from "../Styles";
import { UseFormRegister, UseFormSetValue } from "react-hook-form";
import { FormData } from "../../data/interfaces/dataMessage";

interface SixBoxGridProps {
    register: UseFormRegister<FormData>;
    errors: any;
    setFormData: UseFormSetValue<FormData>;
    onCodeChange: (length: number) => void;
}

const SixBoxGrid: FunctionComponent<SixBoxGridProps> = (props) => {
    const [inputValue, setInputValue] = useState<string>("");
    const [hasError, setHasError] = useState(false);

    function stripNonNumeric(str: string): string {
        const numericRegex = /[0-9]/g;
        const numericChars = str.match(numericRegex);

        return numericChars ? numericChars.join("") : "";
    }
    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, register: UseFormRegister<FormData>) => {
        setHasError(false)
        const strippedValue = stripNonNumeric(event.target.value)
        setInputValue(strippedValue)
        props.onCodeChange(strippedValue.length)
    };

    const validateMFA = (value: string): boolean => {
        let result = value.length === 6
        return result;
    };

    useEffect(() => {
        props.setFormData("Code",inputValue)
    }, [inputValue]);

    return (<>
        <SixBoxGridContainer>
            <DivOuter>
                <DivInner>
                    <Partitioned
                        type="text"
                        id="6BoxGrid"
                        maxLength={6}
                        {...props.register('Code', { validate: { CheckMFA: v => validateMFA(v) } })}
                        value={inputValue}
                        autoFocus
                        onChange={(event) => handleChange(event, props.register)}
                        style={{fontWeight:'500'}}
                    />
                </DivInner>
            </DivOuter>
        </SixBoxGridContainer>
            <div style={{height: '15px', position: "relative", top: '85px'}}>
                {props.errors.Code && (<SixBoxError>{props.errors.Code.message}</SixBoxError>)}
            </div>
    </>);
}

export default SixBoxGrid;